export const LINE_STROKE = "#70FF00";
export const LINE_STROKE_WIDTH = 2;

export const ZONE_STROKE = "#19E3FF";
export const ZONE_FILL = "rgba(25, 227, 255, 0.27)";

// PO QA 3차 y: 도면 라인에도 입/퇴장 방향 화살표 + 라벨 추가.
export const ARROW_HEIGHT = 16;
export const ARROW_TRI_WIDTH = 12;
export const ARROW_TRI_HEIGHT = 8;

export const LINE_DIR_LABEL_STYLE = {
  color: "#2C2D2E",
  backgroundColor: "#FFFFFF",
  fontWeight: 500,
  stroke: LINE_STROKE,
  strokeWidth: 1,
  fontSize: 12,
  fontFamily: "Pretendard Variable, Pretendard, sans-serif",
  radius: 1,
  paddingH: 6,
  paddingV: 4,
  shadow: "0 1px 10px rgba(0,0,0,0.3)",
};

export type CountingLineEventType = "default" | "visit" | "traffic";
export type LineLabelDefs = Record<CountingLineEventType, { left: string; right: string }>;

export const LINE_NAME_LABEL_STYLE = {
  color: "#FFFFFF",
  backgroundColor: "#31B400",
  fontWeight: 600,
  stroke: "#FFFFFF",
  strokeWidth: 1,
  fontSize: 12,
  fontFamily: "Pretendard Variable, Pretendard, sans-serif",
  radius: 1000,
  paddingH: 8,
  paddingV: 4,
  shadow: "0 1px 10px rgba(0,0,0,0.3)",
};

export const ZONE_LABEL_STYLE = {
  color: "#FFFFFF",
  backgroundColor: "#0090A3",
  fontWeight: 600,
  stroke: "#FFFFFF",
  strokeWidth: 1,
  fontSize: 12,
  fontFamily: "Pretendard Variable, Pretendard, sans-serif",
  radius: 1000,
  paddingH: 8,
  paddingV: 4,
  shadow: "0 1px 10px rgba(0,0,0,0.3)",
};

export const BORDER_COLOR = "#5FB3FF";
export const CORNER_COLOR = "white";
export const CORNER_STROKE_COLOR = "#329eff";

export type Coord = { x: number; y: number };
export type EventSource = { type: "line" | "zone"; id: number };

export interface FloorPlanDrawingTarget {
  type: "line" | "zone";
  id: number;
  name: string;
}

// --- Shape group types ---

import type { Circle, Group, Line, Polygon, Polyline } from "fabric";
import type { FabricObject } from "fabric";

export interface LineShapeGroup {
  type: "line";
  id: number;
  editingMode: "size" | "coordinate";
  lineName: string;
  eventType: CountingLineEventType;
  fabricGroup: Group;
  coordinateParts: { displayLine: Line; ep0: Circle; ep1: Circle; directionObjs?: FabricObject[] } | null;
}

export interface ZoneShapeGroup {
  type: "zone";
  id: number;
  editingMode: "size" | "coordinate";
  zoneName: string;
  polygon: Polygon;
  coordinateParts: {
    displayFill: Polyline;
    displayLabel: Group;
    edgeLines: Line[];
    vertexHandles: Circle[];
  } | null;
}

export type ShapeGroup = LineShapeGroup | ZoneShapeGroup;

/** Fabric object with optional __shapeGroup metadata */
export interface TaggedFabricObject extends FabricObject {
  __shapeGroup?: ShapeGroup;
  /** 참조 레이어(다른 카메라) 라인/구역 — 클릭 시 소속 스냅샷으로 이동하기 위한 태그 */
  __refTarget?: { cameraId: number; type: "line" | "zone"; id: number };
  __prevLeft?: number;
  __prevTop?: number;
  __isFloorPlanBg?: boolean;
}

/** Type-safe accessor for __shapeGroup */
export function getShapeGroup(obj: FabricObject): ShapeGroup | undefined {
  return (obj as TaggedFabricObject).__shapeGroup;
}

/** Attach a ShapeGroup to a fabric object */
export function setShapeGroup(obj: FabricObject, sg: ShapeGroup): void {
  (obj as TaggedFabricObject).__shapeGroup = sg;
}
